import React from 'react';
import { connect } from 'react-redux';
import FergusLogo from '../components/FergusLogo.js';
import NavbarEntitySearch from '../components/NavbarEntitySearch';
import MobileNavbarSearch from '../components/MobileNavbarSearch';
import NavbarCallButtons from '../components/NavbarCallButtons';

@connect(
    state => ({
        windowInnerWidth: state.documentProps.windowInnerWidth,
        authUser: state.auth.user
    })
)
export default class NavbarHeader extends React.Component {
    sideBarToggle() {
        this.props.dispatch({type: 'TOGGLE_SIDEBAR_OPEN'});
    }
    render() {
        var isMobile = this.props.windowInnerWidth < 768;

        const findInvoiceWhitelist = ['chris@fergusapp.com', 'henry@fergusapp.com', 'samuel@fergusapp.com', 'marvin@fergusapp.com'];

        return (
            <div className="navbar">
                <div className="navbar-header">
                    <a className="navbar-brand" href="/">
                        <FergusLogo />
                        <span style={{color: '#0F3753'}} className="navbar-brand-text hidden-xs">Candy CRM</span>
                    </a>
                    <ul className="nav navbar-nav navbar-right mobile-navbar-right visible-xs" style={{position: 'absolute', right: 0}}>
                        {isMobile && <MobileNavbarSearch />}
                    </ul>
                </div>
                <ul className="nav navbar-nav navbar-actions navbar-left">
                    <li className="visible-md visible-lg"><a id="main-menu-toggle" onClick={this.sideBarToggle.bind(this)}><i className="fa fa-bars"></i></a></li>
                    <li className="visible-xs visible-sm"><a id="sidebar-menu" onClick={this.sideBarToggle.bind(this)}><i className="fa fa-bars"></i></a></li>
                </ul>
                <NavbarEntitySearch />

				<div className="nav navbar-nav navbar-right" style={{display: 'flex', alignItems: 'center'}}>
					{findInvoiceWhitelist.includes(this.props.authUser.email) && <a href="/find_invoices">Invoice Search</a> }
                    
                    <NavbarCallButtons />
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/NavbarHeader.js